import { Team } from 'src/app/shared/models/team/team';
import { DateRange } from 'src/app/shared/models/dateRange';
import { HistoricalTeam } from 'src/app/shared/models/team/historicalTeam';
import { Workspace } from 'src/app/shared/models/workspace/workspace';
import { SeatTermsStatus } from './seatTermsStatus';

export class TeamHistory {
  public id: string;
  public historicalTeamId: string;
  public teamId: string;
  public teamName: string;
  public positionTitle: string;
  public isActive: boolean;
  public dateRange: DateRange;
  public status: string;
  public seatId: string;
  public seatDateRange: DateRange;
  public seatTermsStatus: SeatTermsStatus;
  public workspaceId: string;
  public workspaceName: string;
  public workspace: Workspace;
  public isInActiveWorkspace: boolean;

  constructor(teamHistory: any = undefined) {
    if (teamHistory) this.setProperties(teamHistory);
  }

  private setProperties(teamHistory: any) {
    this.id =
      teamHistory.historicalTeamId != null ? teamHistory.historicalTeamId : teamHistory.teamId;
    this.historicalTeamId = teamHistory.historicalTeamId;
    this.teamId = teamHistory.teamId;
    this.teamName = teamHistory.teamName;
    this.positionTitle = teamHistory.positionTitle;
    this.isActive = teamHistory.isActive;
    this.dateRange = new DateRange(teamHistory.startDate, teamHistory.endDate);
    this.status = teamHistory.status;
    this.seatId = teamHistory.seatId;
    this.seatDateRange = new DateRange(teamHistory.seatStartDate, teamHistory.seatEndDate);
    this.seatTermsStatus = teamHistory.seatTermsStatus;
    this.workspaceId = teamHistory.workspaceId;
    this.workspaceName = teamHistory.workspaceName;
    this.workspace = teamHistory.workspace;
  }

  static fromHistoricalTeam(historicalTeamRead: HistoricalTeam) {
    let teamHistory = new this();
    if (historicalTeamRead) {
      const id = historicalTeamRead.id;
      teamHistory.id = id;
      teamHistory.historicalTeamId = id;
      teamHistory.teamName = historicalTeamRead.name;
      teamHistory.positionTitle = historicalTeamRead.positionTitle;
      teamHistory.isActive = false;
      teamHistory.dateRange = new DateRange(
        historicalTeamRead.startDate,
        historicalTeamRead.endDate
      );
      teamHistory.seatTermsStatus = historicalTeamRead.seatTermsStatus;
      teamHistory.workspaceId = historicalTeamRead.workspaceId;
      teamHistory.workspace = historicalTeamRead.workspace;
    }
    return teamHistory;
  }

  isThisTeam(team: Team): boolean {
    return this.teamId !== team.id;
  }
}
